import { render, staticRenderFns } from "./ProjectConfigurationPeople.vue?vue&type=template&id=302a1313&scoped=true&"
import script from "./ProjectConfigurationPeople.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigurationPeople.vue?vue&type=script&lang=js&"
import style0 from "./ProjectConfigurationPeople.vue?vue&type=style&index=0&id=302a1313&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302a1313",
  null
  
)

export default component.exports